import { WebshopProduct } from '@cldsystems/ws-api-client';
import { SimpleProductInfo } from '@/types/products/simple-product-info';
import { WithQuantity } from '@/types/products/with-quantity';

const filterInactivatedProducts = (
  allProducts: WebshopProduct[],
  products: SimpleProductInfo[] | WithQuantity<SimpleProductInfo>[],
): SimpleProductInfo[] | WithQuantity<SimpleProductInfo>[] => {
  const allProductIds = new Set(allProducts.map(product => product.id));
  return products.filter(product => allProductIds.has(product.id));
};

export default filterInactivatedProducts;
